import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const PageHeader = ({ title, image }) => (
  <section className='page-header'>
    <div className='page-header__inner'>
      <GatsbyImage image={getImage(image?.localFile)} alt={title} />
      <h1>{ title }</h1>
    </div>
  </section>
)

PageHeader.defaultProps = {
  title: ``,
  image: null,
}

export default PageHeader 